import { render, staticRenderFns } from "./About_Licenses.vue?vue&type=template&id=47185d02&scoped=true"
import script from "./About_Licenses.vue?vue&type=script&lang=js"
export * from "./About_Licenses.vue?vue&type=script&lang=js"
import style0 from "./About_Licenses.vue?vue&type=style&index=0&id=47185d02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47185d02",
  null
  
)

export default component.exports